import React from 'react';
import './AdminFooter.css';

const AdminFooter = () => {
    return (
        <footer className="admin-footer-layout">
            <div className="admin-footer-layout-container">
                <p className="admin-footer-text">
                    Developed & Designed With 
                    <span className="admin-footer-heart" role="img" aria-label="love">❤️</span> 
                    By 
                    <a 
                        href="https://dheersoftwaresolutions.com" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="admin-footer-link"
                    >
                        Dheer Software Solutions
                    </a>
                </p>
            </div>
        </footer>
    );
};

export default AdminFooter;